const BaseComponent = require('base/base-component');
const Service = require('helper/server');
class investmentHome extends BaseComponent {
  constructor () {
    super();
  }
  init () {
     // 访问量统计
    Service.visitCount().then((resp) => {
      this.fillCount(resp);
    });
    window.onload = () => {
      const li=$('.download .list-content2 li');
      li.map((i,x) => {
        if (i>5){
          $(x).hide();
        }
      });
    }
  }

  fillCount ({ total = 0, today = 0, article = 0 }) {
    const $count = this.$el.find('.counting');
    $count.find('.total').text(total);
    $count.find('.today').text(today);
    if (article) {
      $('[name="visitsCount"]').val(article);
    }
  }
}
module.exports = investmentHome;
